import React from 'react'
import { VictoryBar, VictoryStack } from 'victory'

export type IStackedBarSeries = {
    color: string;
    data: {
        x: string | number,
        y: number,
    }[]
}

export const StackedBarChart = (
    {
        series,
        testID,
    }: {
        series: IStackedBarSeries[]
        testID?: string,
    }) => {
    return (
        <div data-testid={testID}>
            <VictoryStack animate={{
                duration: 2000,
                onLoad: {
                    duration: 1000
                }
            }}>
                {
                    series?.map((s: IStackedBarSeries) => (
                        <VictoryBar
                            style={{ data: { fill: s?.color || '#212EEE' } }}
                            data={s?.data}
                        />
                    ))
                }
            </VictoryStack>
        </div>

    )
}

export default StackedBarChart;